import {
  BackendEndpoints, carParkRole, ClientFileInnerType, ClientFileStatus, ClientFileType, ComponentMode,
  CriticalDatasetLabels, criticalPopupMode,
  DangerousState,
  DetectorDirection, DetectorFoodDrink,
  DetectorFoodEat, DetectorSmokeDirection, HumanEntryGlasses,
  HumanEntryHair,
  HumanEntrySex,
  HumanEntryWearingType,
  LightConditionsSun, LightConditionsType,
  RecommendationType, RusavicCategories, UploadVideoTypes,
  UserCriticalEventConfirmation,
  UserCriticalEventRejection
} from '@/enum'
import { localFiltersFields } from '@/models/map/CriticalEventLocalFilters'

export default {
  // application texts
  auth: {
    SignIn: 'Вход',
    profile: 'Профиль',
    adminPanel: 'Поездки',
    charts: 'Статистика',
    reports: 'Отчеты',
    dataset: 'Датасет',
    carParks: 'Автопарки',
    signOut: 'Выход'
  },

  navbar: {
    main: 'Главная',
    features: 'Функциональность',
    papers: 'Статьи',
    press: 'Пресса',
    patents: 'Инт. собственность',
    diplomas: 'Дипломы'
  },

  policyAlert: {
    title: 'Использование cookie-файлов',
    description: 'Мы используем cookie-файлы и прочие отслеживающие технологии для улучшения опыта использования сайта' +
      ' и последующего анализа. Страница <a class="black--text" href="{0}">Политика конфиденциальности</a> содержит больше информации на эту тему. При нажатии кнопки <span class="font-weight-bold">"Согласие"</span>, Вы позволяете нам использовать cookie-файлы и ' +
      'отслеживающие технологии на этом сайте.',
    acceptText: 'При нажатии кнопки <span class="font-weight-bold">"Принять"</span>, Вы позволяете нам использовать cookie-файлы и ' +
      'отслеживающие технологии на этом сайте.',
    acceptButton: 'Принять'
  },

  rusavic: {
    title: 'Аудиовизуальный корпус речевых данных для ассистивных мобильных транспортных систем',
    text: '<div>Многодикторный аудиовизуальный корпус (бимодальная речевая база данных) слитной русской речи с ' +
      'разноракурсными видеоданными и микрофонными аудиоданными RUSAVIC (RUSsian Audio-Visual speech in Cars) ' +
      'содержит записи 20 дикторов-носителей русского языка. ' +
      'В базе данных хранятся аудио- и видеозаписи русской речи, а также информация о разметке данных на ' +
      'акустические единицы речи (фонемы) и визуальные единицы речи (виземы). ' +
      'Корпус русской речи предназначен для обучения и исследования вероятностных моделей системы автоматического ' +
      'распознавания аудиовизуальной русской речи в кабине транспортного средства (легкового автомобиля). ' +
      'Запись аудиовизуальных данных производилась посредством созданного программного комплекса, предназначенного ' +
      'для захвата, синхронизации и объединения аудио- и видеоданных с двух или более смартфонов, расположенных в ' +
      'кабине транспортного средства. ' +
      'Запись речевого корпуса производилась как в условиях дорожного движения, так и холостого хода транспортного ' +
      'средства, т.е. в натурных и полунатурных условиях, максимально приближенных к реальным условиям ' +
      'функционирования. ' +
      'Выполнена полуавтоматическая разметка многомодальных данных на слова, фонемы и виземы. Аудио- и видеофайлы ' +
      'были автоматически обработаны специализированной программой для ЭВМ, а результаты разметки проверены ' +
      'экспертным путем.</div>' +
      '<div class="my-2">Пример записи данных для одного водителя доступен по ссылке: <a target="_blank" rel="noopener noreferrer" href="https://1drv.ms/u/s!Ar_DU2ygGWIUgvUKLF0LD3JDe5LrzA?e=IfoRMK">https://1drv.ms/u/s!Ar_DU2ygGWIUgvUKLF0LD3JDe5LrzA?e=IfoRMK</a></div>' +
      '<div class="my-2">Для загрузки всего набора данных целиком, необходимо сделать запрос по электронной почте: <a href="mailto:alexey.kashevnik@iias.spb.su">alexey.kashevnik@iias.spb.su</a></div>' +
      '<div class="my-2">' +
      '<p>1. Kashevnik A., Lashkov I., Axyonov A., Ivanko D., Ryumin D., Kolchin A., Karpov A. Multimodal Corpus Design for Audio-Visual Speech Recognition in Vehicle Cabin. IEEE Access, IEEE. 2021. Vol. 9. P. 34986–35003.</p>' +
      '<p>2. Ivanko D., Ryumin D., Axyonov A., Kashevnik A., Karpov A. RUSAVIC Corpus: Russian Audio-Visual Speech in Cars. Proceedings of the 13th Language Resources and Evaluation Conference (LREC), Marseille, France, 20-25 June 2022Electronic, WWW. 2022. P. 1555–1559.</p>' +
      '<p>3. Ivanko D., Kashevnik A., Ryumin D., Kitenko A., Axyonov A., Lashkov I., Karpov A. MIDriveSafely: Multimodal Interaction for Drive Safely. 24th ACM International Conference on Multimodal Interaction (ICMI 2022), Bangalore, India, 7-11 November 2022ACM. 2022. P. 733–735.</p></div>',
    tabs: {
      'driver': 'Водитель #{0}',
      'driver_10': 'Водитель #1',
      'driver_20': 'Водитель #2',
      'driver_30': 'Водитель #3',
      'driver_40': 'Водитель #4',
      [RusavicCategories.ALL_ROUTE]: 'Показ маршрута',
      [RusavicCategories.RESET_ROUTE]: 'Сброс маршрута',
      [RusavicCategories.GAS_STATION]: 'Поездка на заправку',
      [RusavicCategories.ROUTE_DURATION]: 'Уточнение длительности поездки',
      [RusavicCategories.ROUTE_ESTIMATION]: 'Уточнение времени прибытия',
      [RusavicCategories.TRAFFIC_OVERALL]: 'Общее состояние дорог',
      [RusavicCategories.JAM_SITUATION]: 'Общее состояние пробок',
      [RusavicCategories.JAM_DURATION]: 'Длительность пробки',
      [RusavicCategories.GAS_STATION_SEARCH]: 'Поиск заправки',
      [RusavicCategories.STREET]: 'Улица',
      [RusavicCategories.HOME_REDIRECTION]: 'Поездка домой',
      [RusavicCategories.LOCATE_NEAREST]: 'Нахождение ближайшего места',
      [RusavicCategories.GASOLINE_PRICE]: 'Стоимость бензина',
      [RusavicCategories.MUSIC_TURN_ON]: 'Включение музыки',
      [RusavicCategories.RADIO_TURN_ON]: 'Включение радио',
      [RusavicCategories.AUDIOBOOK_TURN_ON]: 'Включение аудиокниги',
      [RusavicCategories.MUSIC_TURN_OFF]: 'Выключение музыки',
      [RusavicCategories.SHUT_UP]: 'Просьба замолчать',
      [RusavicCategories.CALL_NUMBER]: 'Позвонить по номеру',
      [RusavicCategories.SEND_MESSAGE]: 'Отправить сообщение',
      [RusavicCategories.SEND_EMAIL]: 'Отправить email',
      [RusavicCategories.ANSWER_CALL]: 'Ответить на звонок',
      [RusavicCategories.DECLINE_CALL]: 'Отклонить звонок',
      [RusavicCategories.BRIGHTNESS_INCREASE]: 'Увеличить яркость',
      [RusavicCategories.BRIGHTNESS_DECREASE]: 'Уменьшить яркость',
      [RusavicCategories.VOLUME_INCREASE]: 'Увеличить громкость',
      [RusavicCategories.VOLUME_DECREASE]: 'Уменьшить громкость',
      [RusavicCategories.TEMPERATURE_OUTSIDE]: 'Температура снаружи',
      [RusavicCategories.ROUTE_CREATION]: 'Создание маршрута',
      [RusavicCategories.AVOID_JAMS]: 'Избегать пробок',
      [RusavicCategories.STREET_SEARCH]: 'Поиск улицы',
      [RusavicCategories.RESTAURANT_SEARCH]: 'Поиск ресторана',
      [RusavicCategories.SET_TIMER]: 'Установка таймера',
      [RusavicCategories.WI_FI_TURN_ON]: 'Включить wi-fi',
      [RusavicCategories.PLAY_LIST_TURN_ON]: 'Включить плейлист',
      [RusavicCategories.PARKING_SHOW]: 'Показать парковку',
      [RusavicCategories.PARKING_SEARCH]: 'Поиск парковки',
      [RusavicCategories.ACCIDENT_AHEAD]: 'Впереди авария',
      [RusavicCategories.CALENDAR_SHOW]: 'Показ календаря',
      [RusavicCategories.REBOOT]: 'Перезагрузка',
      [RusavicCategories.MASSAGE_BACK]: 'Массаж спины',
      [RusavicCategories.SUSPENSION_SOFT]: 'Смягчение подвески',
      [RusavicCategories.LEAVING_RUNAWAY_WARNING_TURN_OFF]: 'Выключение предупреждения о сходе с полосы',
      [RusavicCategories.INTERIOR_LIGHT_TURN_ON]: 'Включить свет в салоне',
      [RusavicCategories.INTERIOR_LIGHT_TURN_OFF]: 'Выключить свет в салоне',
      [RusavicCategories.AIR_CONDITIONER_TURN_ON]: 'Включить кондиционер',
      [RusavicCategories.AIR_CONDITIONER_TURN_OFF]: 'Выключить кондиционер',
      [RusavicCategories.HEATING_TURN_ON]: 'Включить обогрев',
      [RusavicCategories.HEATING_TURN_OFF]: 'Выключить обогрев',
      [RusavicCategories.SIGNALING_TURN_ON]: 'Включить сигнализацию'
    }
  },

  legalInformation: {
    title: 'Политика конфиденциальности',
    header: '<p>Дата вступления в силу: 14 января 2019</p> ' +
      '<p>Drive Safely (далее "мы", "нас" или "наш") является программным комплексом предупреждения аварийных ситуаций водителя транспортного средства, доступным через мобильное приложение Drive Safely (далее "Сервис").</p>' +
      '<p>Drive Safely предоставляется бесплатно и предназначно для использования в ознакомительных целях (как есть).</p>' +
      '<p>В этом документе Вы найдете наши Правила Соблюдения Конфиденциальности и условия публичной оферты. Пожалуйста, внимательно ознакомьтесь с нашей Политикой конфиденциальности, чтобы получить четкое представление о том, как мы собираем, используем или иным образом обрабатываем ваши Персональные Данные, когда Вы используете наш Сервис. ' +
      'Политика в отношении обработки персональных данных, является частью данной Политики конфиденциальности. </p> ' +
      '<p>Мы используем ваши Личные данные для предоставления и повышения качества Сервиса. Используя Сервис, вы соглашаетесь на сбор и использование данных в соответствии с настоящей Политикой конфиденциальности. Если иное не определено в настоящей Политике конфиденциальности, условия, используемые в настоящей Политике конфиденциальности, совпадают по своему значению с нашими Правилами использования и Пользовательским соглашением. </p>',
    informationCollection: {
      title: 'Сбор и использование информации',
      subheader: '<p>Мы собираем несколько различных типов информации для различных целей, чтобы предоставлять и совершенствовать наш Сервис для Вас.</p>',
      dataTypes: {
        title: 'Виды собираемой информации',
        personalData: {
          title: 'Персональная информация',
          description: '<p>При использовании нашего Сервиса мы можем попросить вас предоставить нам определенную личную информацию, которую можно использовать для связи или идентификации вас («Личные данные»). ' +
            'Лично идентифицируемая информация может включать, но не ограничивается:</p>',
          list: [
            'Адрес электронной почты', 'Стаж вождения', 'Пол', 'Дата рождения', 'Статистика использования'
          ]
        }
      },
      usageData: {
        title: 'Данные использования',
        description: '<p>Мы также можем собирать информацию о том, как доступ к Сервису и его использование («Данные об использовании»).</p>' +
          '<p>Эти данные использования могут включать в себя информацию, такую ​​как тип мобильного устройства, который вы используете, уникальный ID вашего мобильного устройства, адрес вашего мобильного устройства по протоколу сети Интернет («IP»), информация об ОС вашего мобильного устройства, информация полученная при помощи датчиков смартфона (камеры, микрофона или похожих устройств) и другие диагностические данные.</p>' +
          '<p>Приложение может использовать технологию GPS (или другую похожую) для определения текущего местоположения с целью определения населенного пункта, в котором вы находитесь и предложить контекстно-ориентированные рекомендации. Если вы не хотите использовать местоположение для целей, указанных выше, вы можете выключить геолокацию для данного приложения в настройках учетной записи или мобильного устройства.</p>'
      }
    },
    useOfData: {
      title: 'Использование данных',
      description: '<p>Drive Safely использует собранные данные для различных целей:</p>',
      list: [
        'Предоставлять и поддерживать наш Сервис',
        'Чтобы уведомить вас об изменениях в нашем Сервисе',
        'Чтобы вы могли участвовать в интерактивных функциях нашего Сервиса, когда вы решите сделать это',
        'Обеспечить поддержку клиентов',
        'Собирать ценную информацию посредством мониторинга деятельности, чтобы мы могли улучшить наш Сервис',
        'Обнаружение, предотвращение и устранение технических проблем'
      ]
    },
    transferOfData: {
      title: 'Передача данных',
      description: '<p>Ваша информация, включая Личные данные, может быть передана на компьютеры, расположенные за пределами вашей государственной, провинциальной, государственной или другой государственной юрисдикции, в которых действуют законы о защите данных, которые могут отличаться от законов вашей юрисдикции.</p> ' +
        '<p>Если вы расположены за пределами Российской Федерации и решили предоставить нам информацию, обратите внимание, что мы передаем данные, включая персональные данные, в Российскую Федерацию и обрабатываем их там.</p> ' +
        '<p>Ваше согласие с настоящей Политикой конфиденциальности, за которой следует ваше представление такой информации, представляет ваше согласие на эту передачу.</p> ' +
        '<p>Мы предпримем все необходимые шаги для обеспечения надежной обработки ваших данных и в соответствии с настоящей Политикой конфиденциальности, и никакая передача ваших персональных данных не будет осуществлена в какой-либо организации или стране, если не будет обеспечен надлежащий контроль, включая безопасность ваших данных данных и другой личной информации.</p>'
    },
    disclosureOfData: {
      title: 'Раскрытие данных',
      legalRequirements: {
        title: 'Правовые требования',
        description: '<p>При определенных обстоятельствах Drive Safely может потребоваться раскрывать ваши Личные данные, ' +
          'если это требуется по закону или в ответ на действительные запросы государственных органов (например, суд или правительственное учреждение).</p>'
      }
    },
    securityOfData: {
      title: 'Безопасность данных',
      description: '<p>Безопасность ваших данных важна для нас, но помните, что ни один способ передачи через Интернет, а также метод электронного хранилища не защищен 100%. Хотя мы стремимся использовать коммерчески приемлемые средства защиты ваших персональных данных, мы не можем гарантировать его абсолютную безопасность.</p>',
      cookieInformation: {
        title: 'Информация о cookie-файлах',
        description: '<p>Мы используем cookie-файлы для идентификации пользователя на сайте. ' +
          'Часть подобных файлов мы оставляем самостоятельно, часть - выставляется третьей стороной. ' +
          'Cookie-файлы третьей стороны могут собирать данные вне нашего сайта.</p>',
        listTitle: 'Данный сайт использует следующие виды cookie-файлов:',
        list: [
          '<p class="font-weight-bold">Функциональные cookie-файлы</p> ' +
          '<p>Данный вид cookie-файлов позволяет получать доступ к защищенным частям сайта. Данный вид файлов не используется в маркетинговых целях.</p>',
          '<p class="font-weight-bold">Аналитические cookie-файлы</p> ' +
          '<p>Данный вид cookie-файлов позволяет нам получать информацию о способах использования пользователями сайта. <a href="https://yandex.ru/support/metrica/general/cookie-usage.html">Yandex AppMetrica</a> является одним из примеров такого вида файлов.</p>'
        ]
      },
      geographicInformation: {
        title: 'Информация о географическом местоположении',
        description: 'Мы используем статические изображения географической карты в качестве подложки при создании скриншотов экрана смартфона для Google Play, а также на этом сайте',
        list: [
          '<p class="font-weight-bold">OpenStreetMap</p>' +
          '<p>OpenStreetMap (OSM) некоммерческий веб-картографический проект по созданию силами сообщества участников — пользователей Интернета географической карты мира.</p>' +
          '<p>Данные проекта распространяются на условиях свободной лицензии Open Database License. ' +
          'Для получения дополнительной информации, пожалуйста, ознакомьтесь с полным текстом лицензии: <a href="https://www.openstreetmap.org/copyright">https://www.openstreetmap.org/copyright</a></p>'
        ]
      },
      analytics: {
        title: 'Аналитика',
        description: 'Мы можем использовать сторонних поставщиков услуг для мониторинга и анализа использования нашего Сервиса.',
        list: [
          '<p class="font-weight-bold">AppMetrica</p>' +
          '<p>AppMetrica – это веб-сервис, который предоставляет такие данные как атрибуция установок, поведенческая аналитика, мониторинг стабильности. Google использует собранные данные для мониторинга и контроля использования нашего Сервиса.</p>' +
          '<p>Дополнительные сведения о Политике конфиденциальности и Условиях использования представлены по ссылке: ' +
          '<a href="https://yandex.ru/legal/metrica_termsofuse/">https://yandex.ru/legal/metrica_termsofuse/</a></p>'
        ]
      }
    },
    linksToOtherSites: {
      title: 'Ссылки на сайты третьих лиц',
      description: '<p>Наш Сервис может содержать ссылки на другие сайты, которые не управляются нами. Если вы нажмете ссылку третьей стороны, вы попадете на сайт третьей стороны. Мы настоятельно рекомендуем вам ознакомиться с Политикой конфиденциальности каждого сайта, который вы посещаете.</p>' +
        '<p>Мы не контролируем и не несем ответственности за контент, политику конфиденциальности или действия сторонних сайтов или служб.</p>'
    },
    childrenPrivacy: {
      title: 'Политика конфиденциальности для детей',
      description: '<p>Наш Cервис не предназначен для лиц младше 18 лет ("дети").</p>' +
        '<p>Мы не сознательно собираем личную информацию от кого-либо, не достигшего возраста 18. Если вы являетесь родителем или опекуном, и вы знаете, что ваши дети предоставили нам Личные данные, свяжитесь с нами. Если мы узнаем, что мы собрали Личные данные у детей без подтверждения родительского согласия, мы предпринимаем шаги для удаления этой информации с наших серверов.</p>'
    },
    changesToThisPrivacyPolicy: {
      title: 'Изменения в этой политике конфиденциальности',
      description: '<p>Мы можем время от времени обновлять нашу Политику конфиденциальности. Мы сообщим вам о любых изменениях, опубликовав новую Политику конфиденциальности на этой странице.</p>' +
        '<p>Мы уведомим вас по электронной почте и / или известному уведомлению о нашей Сервисе до вступления в силу изменения и обновим «дату вступления в силу» в верхней части настоящей Политики конфиденциальности.</p>' +
        '<p>Рекомендуется периодически просматривать эту Политику конфиденциальности для любых изменений. Изменения в этой Политике конфиденциальности действуют, когда они публикуются на этой странице.</p>'
    },
    contactUs: {
      title: 'Свяжитесь с нами',
      description: '<p>Если у вас есть какие-либо вопросы по поводу этой Политики конфиденциальности, пожалуйста, свяжитесь с нами:</p>',
      list: [
        'Email: <a href="mailto:support@mobiledrivesafely.com">support@mobiledrivesafely.com</a>'
      ]
    }
  },

  landing: {
    main: {
      title: 'приложение для мониторинга водителя при управлении транспортным средством c использованием камеры и сенсоров смартфона',
      googleApp: 'Приложение доступно на мобильных устроиствах. Скачайте приложение на Android чтобы попробовать!',
      support: 'Свяжитесь с нами ради поддержки или предложений: ',
      footer: '<a class="black--text" href="https://spcras.ru">СПб ФИЦ РАН</a>, 199178 Санкт-Петербург, 14 линия, 39, Россия',
      privacy: 'Политика конфиденциальности'
    },
    functionality: {
      title: 'Особенности', // 'Мониторинг водителя для выявления опасных состояний усталости и ослабленного внимания во время движения',
      phone: {
        title: 'Повышение безопасности',
        description: 'Генерация звуковых уведомлений и контекстно-ориентированных персонализированных рекомендаций'
      },
      map: {
        title: 'Удобство использования',
        description: 'Запуск мобильного приложения совместно с привычной водителю навигационной системой'
      },
      stats: {
        title: 'Статистика поездок',
        description: 'Отображение статистики совершенных поездок на карте для повышения эффективности вождения',
        labels: [
          'Маршрут поездки с опасным состоянием',
          'Общая статистика поездки'
        ]
      },
      personification: {
        title: 'Персонификация',
        description: 'Обучение системы на базе данных водителей'
      }
    },
    papers: {
      title: 'Публикации о проекте',
      conferences: 'Конференции',
      journals: 'Журналы'
    },
    press: {
      title: 'Пресса о проекте'
    },
    patents: {
      title: 'Интеллектуальная собственность'
    },
    diplomas: {
      title: 'Дипломы'
    }
  },

  statisticsCard: {
    title: 'Общая статистика'
  },

  map: {
    travelToolbar: {
      travel: 'Поездка',
      timePretext: 'от'
    },
    travelTabs: {
      calendar: 'Календарь',
      driver: 'Водитель'
    },
    travelMap: {
      toolbar: {
        map: 'Карта'
      },
      localFilters: {
        tooltip: 'Фильтрация событий',
        title: 'Фильтрация событий',
        sections: {
          [localFiltersFields.DANGEROUS_STATE_FILTERS]: 'Тип события',
          [localFiltersFields.USER_STATE_FILTERS]: 'Состояние события'
        }
      },
      purePointCardTitle: 'Информация трека',
      purePointCard: {
        title: 'Информация трека',
        clearAll: 'Удалить выбранные точки'
      },
      iconedTravelStats: {
        start: 'Начало поездки',
        finish: 'Конец поездки',
        startProgram: 'Начало программы',
        startReal: 'Начало поездки',
        correctDate: 'Время, взятое из событий',
        errorDate: 'Время, взятое из таблицы road_trip'
      }
    },
    managerMap: {
      toolbarTitle: 'Водители',
      travelCard: {
        start: 'Начало'
      },
      localFilters: {
        title: 'Фильтрация поездок',
        filters: {
          isOnlyNano: 'Только Nano-водители?',
          timeRangeFilter: {
            title: 'Поездки внутри временного промежутка'
          }
        },
        apply: 'Обновить таблицу'
      },
      headers: {
        style: 'Стиль',
        username: 'Водитель',
        travels: 'Поездки',
        distance: 'Дистанция (км)',
        latestTrip: 'Последняя поездка',
        drowsiness: 'Сонливость',
        distraction: 'Невнимательность',
        [DangerousState.DISTRACTION_NO_ATTENTION]: 'Отвлечение внимания',
        [DangerousState.DISTRACTION_NO_FACE]: 'Лицо не в кадре',
        nobelt: 'Без ремня',
        cameraSabotage: 'Саботаж камеры',
        cellphoneUse: 'Использование телефона',
        eatingCount: 'Прием пищи',
        smokingCount: 'Курение'
      },
      style: {
        green: 'Частота критических событий низкая',
        yellow: 'Частота критических событий средняя',
        red: 'Частота критических событий большая'
      },
      tripCard: {
        tripStart: 'Начало поездки',
        distance: 'Дистанция'
      },
      filterHeaders: {
        latestTrip: 'Даты поездок',
        duration: 'Длительность',
        lowerBound: 'Нижняя граница',
        upperBound: 'Верхняя граница',
        timeRange: 'Промежуток времени',
        dateRange: 'Даты поездок',
        driverHeader: 'Имя водителя'
      },
      noTrips: 'Поездки не найдены',
      defaultSettings: 'Настройки по умолчанию',
      demoVideo: 'Выбранные видео',
      syncDefaultSettings: 'Синхронизировать',
      syncAll: 'Синхронизировать всех водителей',
      defaultSettingsUsers: 'Водители',
      fineTuningSettings: 'Тонкая настройка',
      uncheckedStates: 'Нерассмотренные состояния: {0}',
      reportOff: 'Поездка исключена из отчетности'
    },
    mapDialog: {
      nextTrip: 'Следующая поездка',
      previousTrip: 'Предыдущая поездка',
      tripReportStatus: 'Отчетность',
      tripReportStatusFailure: 'Произошла ошибка при изменении статуса включения поездки в отчетность!',
      tripReportStatusSuccess: 'Статус включения поездки в отчетность был изменен!',
      tripReportDialog: {
        title: 'Подтверждение статуса включения поездки в отчетности',
        includeText: 'Вы хотите включить поездку в отчетность?',
        excludeText: 'Вы действительно хотите исключить поездку из отчетности?',
        confirm: 'Да',
        reject: 'Нет'
      },
      tripAdditionalStatisticsLabel: 'Загрузка дополнительной статистики поездки',
      tripAdditionalStatisticsFailure: 'Произошла ошибка при считывании дополнительной статистики поездки!'
    },
    tableFilter: {
      all: 'Все',
      clear: 'Очистить',
      clearAll: 'Очистить все',
      reset: 'Очистить',
      date: 'Дата',
      duration: {
        seconds: 'секунды',
        minutes: 'минуты',
        hours: 'часы',
        days: 'дни'
      }
    },
    driverTrips: {
      actions: {
        view: 'Посмотреть поездку',
        stats: 'Загрузить статистику',
        video: 'Загрузить видео архив с критическими событиями'
      }
    },
    tripDownload: {
      title: 'Загрузка статистики поездки',
      statisticsType: {
        title: 'Вид статистики: ',
        pure: 'Общая',
        critical: 'Крит. события'
      },
      formatType: {
        title: 'Формат данных'
      },
      download: 'Загрузить'
    },
    videoDownload: {
      title: 'Загрузка видео архива с крит. событиями',
      text: 'В архиве будет находиться {0} видео. Формирование и загрузка архива может занять некоторое время.',
      download: 'Загрузить'
    },
    tripScroll: {
      title: 'Другие поездки'
    },
    travelStatsCard: {
      title: 'Информация о поездке',
      measurementsDialogButton: 'Измерение времени загрузки поездки',
      measurementsDialog: {
        title: 'Измерение времени загрузки поездки (в секундах)'
      },
      clientFilesDialogButton: 'Файлы водителя'
    },
    travelSelector: {
      toolbarTitle: 'Выбор поездки',
      calendar: 'Календарь',
      travels: 'Поездки',
      show: 'Показать',
      userSelector: {
        drivers: 'Водители',
        placeholder: 'Начните печатать для поиска...'
      }
    },
    travelStats: {
      toolbarTitle: 'Статистика поездки',
      averageSpeed: {
        title: 'Ср. скорость',
        postfix: 'км/ч'
      },
      maxSpeed: {
        title: 'Макс. скорость',
        postfix: 'км/ч'
      },
      maxAcceleration: {
        title: 'Макс. ускорение',
        postfix: 'м/cек<sup>2</sup>'
      },
      distance: {
        title: 'Дистанция',
        postfix: 'км'
      },
      duration: {
        title: 'Длительность'
      },
      distractionCount: {
        title: 'Кол-во невнимательностей'
      },
      distractionNoAttentionCount: {
        title: 'Кол-во отвлечения внимания'
      },
      distractionNoFaceCount: {
        title: 'Кол-во лица не кадре'
      },
      drowsinessCount: {
        title: 'Кол-во сонливостей'
      },
      yawningCount: {
        title: 'Кол-во зевоты'
      },
      nobeltCount: {
        title: 'Кол-во непристегнутых ремней'
      },
      cameraSabotage: {
        title: 'Кол-во саботажей камеры'
      },
      cellphoneUse: {
        title: 'Кол-во использований телефона'
      },
      eatingCount: {
        title: 'Кол-во приемов пищи'
      },
      smokingCount: {
        title: 'Кол-во курения'
      },
      dateStart: {
        title: 'Начало поездки'
      },
      actions: {
        title: 'Действия'
      }
    },
    mapHelp: {
      title: 'Состояния критических событий',
      unknownState: 'Непросмотренное событие',
      ignoredState: 'Проигнорированное событие',
      approvedState: 'Одобренное событие',
      rejectedState: 'Отклоненное событие',
      retrainedState: 'Отправленное на дообучение событие',
      approvedRetrainedState: 'Подтвержденное с дообучением событие'
    },
    criticalPopup: {
      title: {
        [DangerousState.DISTRACTION]: 'Невнимательность',
        [DangerousState.DISTRACTION_NO_ATTENTION]: 'Отвлечение внимания',
        [DangerousState.DISTRACTION_NO_FACE]: 'Лицо не в кадре',
        [DangerousState.DROWSINESS]: 'Сонливость',
        [DangerousState.BELT_NOT_FASTEN]: 'Ремень не пристегнут',
        [DangerousState.YAWNING]: 'Зевота',
        [DangerousState.CAMERA_SABOTAGE]: 'Саботаж камеры',
        [DangerousState.CAMERA_OFF]: 'Камера не работает',
        [DangerousState.CELLPHONE_USE]: 'Использование телефона',
        [DangerousState.EATING]: 'Прием пищи',
        [DangerousState.SMOKING]: 'Курение',
        [DangerousState.UNKNOWN]: 'Неизвестная опасность'
      },
      criticalMode: {
        [criticalPopupMode.DATASET]: 'Карта',
        [criticalPopupMode.MAP]: 'Датасет критических событий'
      },
      criticalVideo: {
        title: 'Синхронное воспроизведение видео'
      },
      stateHelper: {
        [UserCriticalEventConfirmation.APPROVE]: 'Критическое событие было подтверждено',
        [UserCriticalEventConfirmation.REJECT]: 'Критическое событие было опровергнуто',
        [UserCriticalEventConfirmation.RETRAIN]: 'Критическое событие отправлено на переобучение'
      },
      recommendations: {
        [RecommendationType.DRINK_COFFEE_CAFE]: 'Чашка кофе может помочь взбодриться',
        [RecommendationType.DRINK_COFFEE_HOTEL]: 'Чашка кофе может помочь взбодриться',
        [RecommendationType.RADIO_AND_MUSIC_ON]: 'Музыка или любимая радиостанция поможет в этом',
        [RecommendationType.RADIO_AND_MUSIC_OFF]: 'Музыка и радио может мешать управлению',
        [RecommendationType.TALK_WITH_PASSENGERS]: 'Беседа с пассажиром может помочь',
        [RecommendationType.NO_TALK_WITH_PASSENGERS]: 'Разговор с пассажиром не должен отвлекать',
        [RecommendationType.CONCENTRATE_ON_ROAD]: 'Сконцентрируйся на дороге',
        [RecommendationType.COOL_CAR_INTERIOR]: 'Проветривание салона позволит взбодриться',
        [RecommendationType.SING_YOURSELF]: 'Пение помогает отогнать сон',
        [RecommendationType.PULL_OVER]: 'Остановка и отдых необходим для безопасного вождения',
        [RecommendationType.ADJUST_CABIN_LIGHTNING]: 'Подсветка в салоне автомобиля поможет не дать заснуть',
        [RecommendationType.STOP_NEXT_REST_AREA]: 'Сделайте остановку в ближайшем месте отдыха',
        [RecommendationType.CHANGE_DRIVERS]: 'Смена водителя может помочь',
        [RecommendationType.STOP_STRETCH_EXCERSIZE]: 'Остановитесь и сделайте небольшую разминку для тела',
        [RecommendationType.ADJUST_SEAT_POSITION]: 'Подсветка в салоне автомобиля поможет не дать заснуть'
      },
      nextEvent: 'Следующее событие',
      previousEvent: 'Предыдущее событие',
      mapPopup: 'За 10 секунд до события',
      sections: {
        general: {
          title: 'Общее',
          eventStart: 'Начало состояния',
          eventEnd: 'Конец состояния',
          duration: 'Длительность',
          recommendation: 'Рекомендация',
          criticalParamValue: 'Крит. значения',
          locationAccuracy: 'Точность',
          satelliteCount: 'Спутники',
          fixedCoordinates: 'Координаты изменены: низкая точность и/или малое кол-во спутников!'
        },
        titles: {
          general: 'Общее',
          rejection: 'Отказ',
          video: 'Видео',
          settings: 'Настройки',
          deviceInfo: 'Устройство',
          criticalParamValue: 'Крит. значения',
          tag: 'Мета-информация',
          videoTag: 'Видео'
        },
        context: {
          title: 'Контекст',
          averageSpeed: {
            title: 'Средняя скорость',
            postfix: 'км/ч'
          },
          averageAcceleration: {
            title: 'Среднее ускорение',
            postfix: 'м/cек<sup>2</sup>'
          },
          maxAcceleration: {
            title: 'Максимальное ускорение',
            postfix: 'м/cек<sup>2</sup>'
          },
          minAcceleration: {
            title: 'Минимальное ускорение',
            postfix: 'м/cек<sup>2</sup>'
          },
          distance: {
            title: 'Дистанция',
            postfix: 'км'
          }
        },
        video: {
          title: 'Видео',
          tabs: {
            [UploadVideoTypes.DRIVER]: 'Водитель',
            [UploadVideoTypes.ROAD]: 'Дорога'
          }
        },
        settings: {
          title: 'Настройки'
        },
        deviceInfo: {
          title: 'Устройство'
        }
      },
      rejectedEvent: {
        reason: 'Причина: ',
        retrain: 'Дообучение: '
      },
      retrainStates: {
        title: 'Переобучение состояния',
        noneSelected: 'Состояние не выбрано',
        emptyStateError: 'Необходимо выбрать состояние для переобучения!'
      },
      rejectDialog: {
        title: 'Неправильный тип состояния',
        rejectComment: 'Комментарий',
        retrainLabel: 'Состояние для дообучения',
        noneSelected: 'Причина не выбрана',
        emptyStateError: 'Необходимо выбрать причину для отказа!',
        states: {
          [UserCriticalEventRejection.BUG]: 'Ошибка системы',
          [UserCriticalEventRejection.SCRATCH]: 'Почесывание',
          [UserCriticalEventRejection.AUDIO_PANEL]: 'Магнитола',
          [UserCriticalEventRejection.ERROR]: 'Ошибка детектирования',
          [UserCriticalEventRejection.SUN_GLARE]: 'Блики солнца',
          [UserCriticalEventRejection.RETRAIN]: 'Дообучение',
          [UserCriticalEventRejection.BLINK]: 'Прищуривание',
          [UserCriticalEventRejection.GLASSES]: 'Использование очков',
          [UserCriticalEventRejection.OTHER]: 'Прочее'
        },
        help: {
          [UserCriticalEventRejection.BUG]: 'Саботаж в самом старте запуска',
          [UserCriticalEventRejection.SCRATCH]: 'Водитель чешет нос, ухо, голову, глаз и при этом смотрит на дорогу',
          [UserCriticalEventRejection.AUDIO_PANEL]: 'Водитель смотрит в районе магнитолы справа, чаще всего там установлен телефон',
          [UserCriticalEventRejection.ERROR]: 'Поведение водителя безопасное и соответствует типу события, которое система определила',
          [UserCriticalEventRejection.SUN_GLARE]: 'Ложное срабатывание системы из-за бликов солнца',
          [UserCriticalEventRejection.RETRAIN]: 'Система определила неверный тип или не заметила его вовсе',
          [UserCriticalEventRejection.BLINK]: 'Яркое солнце, глаза прищурены',
          [UserCriticalEventRejection.GLASSES]: 'Водитель в темных очках',
          [UserCriticalEventRejection.OTHER]: 'Любые другие причины некорректного определения типа события'
        }
      },
      buttons: {
        confirm: 'Подтвердить',
        reject: 'Опровергнуть',
        retrain: 'Переобучить',
        retrainApproved: 'Подтвердить с дообучением'
      },
      userConfirm: {
        isTurning: 'Поворот?',
        isCameraCorrect: 'Камера установлена правильно?',
        isLookDown: 'Водитель смотрит вниз?',
        isWearingMask: 'Водитель носит маску?'
      },
      criticalStatisticsFilterMenu: {
        title: 'Фильтрация длительности',
        popup: 'Доп. статистика по критическим событиям'
      },
      allCameraCorrectDialog: {
        button: 'Утвердить корректное расположение камеры во время всей поездки',
        title: 'Подтверждение расположения камеры во время всей поездки',
        text: 'При нажатии кнопки <span class="light-green--text">"Да"</span> для всех событий будет подтверждено поле "Камера установлена правильно?"',
        confirm: 'Да',
        reject: 'Нет'
      },
      allIsWearingMaskDialog: {
        button: 'Утвердить наличие маски на водителе во время всей поездки',
        title: 'Подтверждение наличия маски на водителе во время всей поездки',
        text: 'При нажатии кнопки <span class="light-green--text">"Да"</span> для всех событий будет подтверждено поле "Водитель в маске?"',
        confirm: 'Да',
        reject: 'Нет'
      }
    },
    drowsinessCaption: [
      'Максимальная бдительность в дороге', // Extremely alert
      'Повышенная бдительность в дороге', // Very alert
      'Обычная бдительность в дороге', // Alert
      'Больше бдительный в дороге, чем сонливый', // Rather alert
      'Ни бдительный, ни сонливый', // Neither alert nor sleepy
      'Некоторые признаки сонливости', // Some signs of sleepiness
      'Сонливость; водитель бодрствует', // Sleepy, but no difficulty remaining awake
      'Сонливость; водитель принимает усилия, чтобы не уснуть', //  Sleepy, some effort to keep alert
      'Максимальная сонливость; водитель борется со сном' // Extremely sleepy, fighting sleep
    ],
    userFeedbackForm: {
      rateTravel: 'Оценить поездку',
      travelRating: 'Оценивание поездки',
      drowsinessRating: 'Оценка сонливости',
      drivingStyle: {
        title: 'Оценка стиля вождения',
        calm: 'Спокойный',
        aggressive: 'Агрессивный'
      }
    },
    userFeedback: {
      travelRating: 'Оценка поездки',
      drowsiness: 'Сонливость:',
      drivingStyle: 'Стиль вождения:'
    },
    textCopyPopup: {
      title: 'Ссылка на поездку',
      copy: 'Копировать',
      success: 'Ссылка скопирована!',
      failure: 'Произошла ошибка во время копирования!'
    },
    driverSettings: {
      title: 'Настройки {0}',
      defaultSettingsTitle: 'Настройки по умолчанию (id = {0})',
      tabs: {
        situation: 'Опасное состояние',
        distraction: 'Невнимательность',
        distractionNoFace: 'Лицо не в кадре',
        distractionNoAttention: 'Отвлечение внимания',
        drowsiness: 'Сонливость',
        yawn: 'Зевота',
        autoCalibrate: 'Автокалибровка',
        belt: 'Ремень',
        general: 'Общее',
        sabotage: 'Саботаж камеры',
        cellphone: 'Использование телефона',
        eating: 'Прием пищи',
        smoking: 'Курение',
        cameraOff: 'Саботаж, не работает камера',
        handsFrame: 'Руки в кадре',
        notifications: 'Уведомления',
        serviceMessages: 'Сервисные уведомления'
      },
      tabContentTitles: {
        situation: 'Временные рамки опасного состояния',
        distraction: 'Параметры ослабленного внимания',
        drowsiness: 'Параметры сонливости',
        yawn: 'Параметры зевоты',
        autoCalibrate: 'Параметры автокалибровки',
        belt: 'Параметры ремня',
        general: 'Общие настройки',
        filters: 'Фильтры',
        settings: 'Настройки'
      },
      iconedLabels: {
        autoCalibrate: 'Автокалибровка',
        deviceSettings: 'Настройки устройства',
        statisticsSettings: 'Настройки статистики',
        soundSettings: 'Настройки звука',
        recommendationAndDangerousStateSettings: 'Настройки рекомендация и состояний',
        detectorsSettings: 'Параметры работы детекторов',
        detectorsStopSettings: 'Управление остановкой работы детекторов'
      },
      response: {
        ok: 'Профиль водителя обновлен',
        error: 'Возникла проблема при обновлении профиля водителя! Обратитесь к логам для деталей',
        syncOk: 'Синхронизация с настройками по умолчанию завершена',
        syncError: 'Возникла проблема при синхроинзации с настройками по умолчанию! Обратитесь к логам для деталей',
        driverSyncOk: 'Синхронизация водителей с настройками по умолчанию завершена',
        driverSyncError: 'Возникла проблема при синхроинзации водителей с настройками по умолчанию! Обратитесь к логам для деталей'
      },
      labels: {
        intervalBetweenDetectDangersBetween: 'Время до распознавания следующего опасного состояния (мс)',
        periodInDetectDanger: 'Время определения опасного состояния (мс)',
        isDetectDistraction: 'Определять ослабленное внимание?',
        leftHeadAnglePref: 'Поворот головы влево °',
        rightHeadAnglePref: 'Поворот головы вправо °',
        calibratedHeadAngleYawPref: 'Значение калибровки поворота головы °',
        calibratedHeadAnglePitchPref: 'Значение калибровки наклона головы °',
        upHeadAnglePref: 'Наклон головы вверх °',
        downHeadAnglePref: 'Наклон головы вниз °',
        isDetectDrowsiness: 'Определять сонливость?',
        leftEyeOpennessPercentagePref: 'Порог открытости левого глаза (0–100%)',
        rightEyeOpennessPercentagePref: 'Порог открытости правого глаза (0–100%)',
        perclosPref: 'PERCLOS (0..1)',
        headRotateAngleDrowsinessDetect: 'Угол поворота головы для определения состояния °',
        yawnCount: 'Кол-во зевков определения зевоты',
        thresholdMouthOpenDetect: 'Степень открытости рта',
        yawnPeriodDetect: 'Время определения для состояния зевоты (с)',
        driverStatisticsEnabled: 'Отправлять статистику на сервер?',
        driverStatisticsSyncWifi: 'Отправка статистики только по Wi-Fi?',
        trainModeEnabled: 'Режим обучения системы',
        finishAppOnCloseNavig: 'Закрывать приложение при остановке навигации?',
        settingPlayBeepEvent: 'Звуковой сигнал для опасной ситуации?',
        settingPlayBeepDangerEvent: 'Звуковой сигнал для опасного состояния?',
        isVibrate: 'Вибрация при нажатии?',
        audioLevelPref: 'Уровень громкости',
        screenBrightness: 'Уровень яркости',
        intervalBetweenRecommendationsSec: 'Интервал между рекомендациями (с)',
        travelTimeLastStopHours: 'Время до остановки в кафе/отеле/заправочной станции (чч.мм)',
        autoCalibrateEnabled: 'Включить автокалибровку головы?',
        autoCalibrateSpeed: 'Мин. скорость калибровки (км/ч)',
        autoCalibrateFirstPeriod: 'Первый интервал калибровки положения головы (сек)',
        autoCalibrateRefineInterval: 'Время до начала калибровки положения головы (сек)',
        isDetectSeatBelt: 'Отслеживать ремень безопасности?',
        periodDetectDrowsiness: 'Время распознования состояния (мс)',
        minFramesDetectDrowsiness: 'Минимальное количество определяемых ситуаций',
        minFramesDetectDistraction: 'Минимальное количество определяемых ситуаций',
        isDetectCameraSabotage: 'Определять саботаж камеры?',
        maxFramesDetectSabotage: 'Количество анализируемых изображений',
        minFramesDetectSabotage: 'Количество ситуаций с саботажем камеры',
        notificationVocalize: 'Озвучивать',
        notificationInterval: 'Время повторного состояния (с)',
        confidenceDetectGazeRadio: 'Порог взгляда на магнитолу',
        mirrorImage: 'Отразить изображение камеры по горизонтали?',
        mirrorImageDriver: 'Отразить изображение камеры водителя по горизонтали?',
        mirrorImageRoad: 'Отразить изображение камеры дороги по горизонтали?',
        periodDetectBelt: 'Время распознования состояния (мс)',
        periodDetectSabotage: 'Время распознования состояния (мс)',
        headTiltAngleDrowsinessDetect: 'Угол наклона головы для определения состояния °',
        mouthWidthRatioSmile: 'Степень ширины рта при улыбке (0..1)',
        distractionIntervalSpeedStart: 'Стартовая скорость определения невнимательности (км/ч)',
        distractionIntervalTimeDetectStart: 'Начало интервала определения невнимательности (мс)',
        distractionIntervalSpeedEnd: 'Конечная скорость определения невнимательности (км/ч)',
        distractionIntervalTimeDetectEnd: 'Конец интервала определения невнимательности (мс)',
        showServiceMessages: 'Использовать',
        isDetectCellPhone: 'Определять телефон?',
        periodDetectCellPhone: 'Время распознования состояния (мс)',
        confidenceDetectCellPhone: 'Уверенность определения телефона',
        isDetectEating: 'Определять прием пищи?',
        periodDetectEating: 'Время распознования состояния (мс)',
        confidenceDetectEating: 'Уверенность определения приема пищи',
        isDetectSmoking: 'Определять курение?',
        periodDetectSmoking: 'Время распознования состояния (мс)',
        confidenceDetectSmoking: 'Уверенность определения курения',
        mouthWidthCalibrated: 'Значение калибровки ширины рта',
        isDetectDistractionNoFace: 'Определять лицо не в кадре?',
        isDetectDistractionNoAttention: 'Определять отвлечение внимания?',
        ratioFramesDistractionNoFace: 'Минимальная доля кадров без лица',
        ratioFramesDistractionNoAttention: 'Минимальная доля кадров с отвлечением внимания',
        timeDetectOneYawn: 'Время для определения одного зевка (мс)',
        showDebugInfoVideo: 'Вывести отладочную информацию на видео',
        confidenceDetectFrontBeltTop: 'Уверенность определения верхней части ремня спереди',
        confidenceDetectFrontBeltBottom: 'Уверенность определения нижней части ремня спереди',
        isDetectBackBelt: 'Определять ремень за спиной?',
        confidenceDetectBackBeltTop: 'Уверенность определения верхней части ремня сзади',
        confidenceDetectBackBeltBottom: 'Уверенность определения нижней части ремня сзади',
        detectorStopRepeatCount: 'Число повторений срабатывания детектора',
        detectorStopActivatePeriod: 'Интервал срабатывания детектора (с)',
        detectorStopSuspendTime: 'Время отключения детектора (с)',
        isDetectCameraCalibrate: 'Определять наличие калибровки камеры?',
        yawnFramesRatioDetect: 'Минимальная доля кадров определения зевоты',
        minSpeedDrowsiness: 'Мин. скорость для определения опасного состояния (км/ч)',
        minSpeedDistractionNoFace: 'Мин. скорость для определения опасного состояния (км/ч)',
        minSpeedDistractionNoAttention: 'Мин. скорость для определения опасного состояния (км/ч)',
        minSpeedCameraSabotage: 'Мин. скорость для определения опасного состояния (км/ч)',
        minSpeedBeltNotFasten: 'Мин. скорость для определения опасного состояния (км/ч)',
        minSpeedCellPhone: 'Мин. скорость для определения опасного состояния (км/ч)',
        minSpeedSmoking: 'Мин. скорость для определения опасного состояния (км/ч)',
        minSpeedEating: 'Мин. скорость для определения опасного состояния (км/ч)',
        beltModelFramesPerSecond: 'Обработка нейронной сети ремня (кадр/с)',
        percentFramesDetectBelt: 'Процент ситуаций с непристегнутым ремнем',
        percentFramesDetectPhone: 'Процент ситуаций с телефоном',
        percentFramesDetectEating: 'Процент ситуаций с потреблением еды',
        percentFramesDetectSmoking: 'Процент ситуаций с курением',
        detectorLowLightThreshold: 'Минимальный порог освещенности для работы детекторов',
        imageRotateAngle: 'Угол поворота изображения (по часовой стрелке)'
      },
      unsavedDialog: {
        title: 'Замечены несохраненные изменения!',
        text: 'Вы действительно хотите выйти без сохранения изменений?',
        return: 'Вернуться'
      },
      syncDialog: {
        title: 'Подтверждение синхронизации',
        textSingle: 'Вы действительно хотите синхронизировать данного водителя?',
        textSelected: 'Вы действительно хотите синхронизировать выбранных водителей?',
        textAll: 'Вы действительно хотите синхронизировать ВСЕХ водителей?',
        reject: 'Нет',
        confirm: 'Да'
      },
      sync: 'Синхронизировать с настройками по умолчанию'
    },
    demoVideo: {
      title: 'Выбранные видео',
      videoType: {
        title: 'Тип видео',
        demo: 'Demo',
        dataset: 'Dataset'
      },
      stateSelector: {
        title: 'Выбор опасных состояний',
        allSelected: 'Все опасные состояния выбраны'
      }
    },
    requests: {
      files: 'Файлы водителей',
      syncFileData: 'Получить файлы водителя',
      emptyData: 'Файлы водителя не обнаружены - заявка уже была отправлена.',
      requestFile: 'Запросить файл',
      showFile: 'Показать файл',
      downloadFile: 'Сохранить файл',
      historyLog: 'История файла',
      tabs: {
        [ClientFileType.VIDEO]: 'Видео ({0})',
        [ClientFileType.LOG]: 'Логи ({0})'
      },
      dataIterator: {
        name: 'Файл',
        type: 'Тип',
        time: 'Время',
        innerType: 'Категория',
        size: 'Размер',
        status: 'Статус',
        actions: 'Действия',
        search: 'Файл / водитель',
        filters: 'Фильтры',
        states: {
          [ClientFileStatus.REQUESTED]: 'Запрошено',
          [ClientFileStatus.INCOMPLETE]: 'Не запрошено',
          [ClientFileStatus.SAVED]: 'Сохранено',
          [ClientFileStatus.LOST]: 'Утрачено'
        },
        categories: {
          [ClientFileInnerType.DASHCAM_DRIVER]: 'Видеорегистратор (водитель)',
          [ClientFileInnerType.DASHCAM_ROAD]: 'Видеорегистратор (дорога)',
          [ClientFileInnerType.CRITICAL_VID_DRIVER]: 'Видео события (водитель)',
          [ClientFileInnerType.CRITICAL_VID_ROAD]: 'Видео события (дорога)',
          [ClientFileInnerType.LOGS_APP_PURE]: 'Файлы приложения',
          [ClientFileInnerType.LOGS_APP_ARCHIVE]: 'Архивы приложения',
          [ClientFileInnerType.LOGS_SYSTEM]: 'Файлы системы',
          [ClientFileInnerType.UNKNOWN]: 'Без категории',
          null: 'Без категории'
        },
        types: {
          [ClientFileType.VIDEO]: 'Видео',
          [ClientFileType.LOG]: 'Логи'
        },
        statesNumbered: {
          [ClientFileStatus.REQUESTED]: 'Запрошено: {0}',
          [ClientFileStatus.INCOMPLETE]: 'Не запрошено: {0}',
          [ClientFileStatus.SAVED]: 'Сохранено: {0}',
          [ClientFileStatus.LOST]: 'Утрачено: {0}'
        }
      }
    }
  },
  mapSettings: {
    title: 'Общие настройки',
    videoSettingsTitle: 'Настройки видео',
    hideReviewedEvents: 'Скрывать оцененные критические события',
    hideAllEventsExceptAccepted: 'Скрыть все события, кроме одобренных',
    hideSmallTrips: 'Скрывать короткие поездки',
    hideViewedTrips: 'Скрывать поездки с всеми просмотренными событиями',
    clusterEvents: 'Применять кластеризацию к критическим событиям',
    clusterEventTimePeriod: 'Периодичность критиических событий (мс)',
    autoScrollManipulatedEvents: 'Прокручивать события при манипуляции со статусом',
    videoWidth: 'Ширина видео'
  },
  timezoneSettings: {
    title: 'Настройка часового пояса',
    isActive: 'Использовать выбранный часовой пояс',
    userTimezone: 'Часовые пояса'
  },
  videoSettings: {
    title: 'Настройки видео',
    videoWidth: 'Ширина видео водителя',
    videoRoadWidth: 'Ширина видео дороги',
    autoPlayVideo: 'Автоматически проигрывать видео?'
  },
  criticalDataset: {
    title: 'Датасет критических событий',
    titleNew: 'Новое событие в датасете',
    titleOld: 'Существующее событие в датасете',
    labels: {
      [CriticalDatasetLabels.SLIDES]: 'Галерея',
      [CriticalDatasetLabels.HUMAN]: 'Человек',
      [CriticalDatasetLabels.LIGHT_CONDITIONS]: 'Условия освещения',
      [CriticalDatasetLabels.ACTIONS]: 'Действия',
      [CriticalDatasetLabels.DETECTORS]: 'Детекторы'
    },
    slides: {
      alert: 'Не получилось загрузить изображения критического события! Пожалуйста, обратитесь в команду поддержки.'
    },
    buttons: {
      next: 'Следующий',
      previous: 'Предыдущий',
      send: 'Отправить'
    },
    popup: {
      success: 'Событие было успешно занесено в датасет!',
      failure: 'Ошибка во время занесения события в датасет.'
    },
    [CriticalDatasetLabels.HUMAN]: {
      sex: 'Пол:',
      glasses: 'Очки на лице?',
      glassesDataset: 'Очки на лице',
      wearingType: 'Одежда водителя',
      wearingTypeComment: 'Комментарий для одежды',
      wearingColorBeltSimilar: 'Одежда одного цвета с ремнем?',
      wearingColorBeltSimilarDataset: 'Одежда одного цвета с ремнем',
      hair: 'Длинные волосы?',
      hairDataset: 'Длинные волосы'
    },
    [CriticalDatasetLabels.LIGHT_CONDITIONS]: {
      type: 'Условия',
      sun: 'Направление солнца',
      rain: 'Дождь?',
      rainDataset: 'Дождь'
    },
    [CriticalDatasetLabels.ACTIONS]: {
      handsOnWheel: 'Руки на руле (частично закрывают руль)?',
      handsOnWheelDataset: 'Руки на руле',
      headphones: 'Проводные наушники?',
      headphonesDataset: 'Проводные наушники',
      leftHandHidesBelt: 'Левая рука закрывает ремень?',
      leftHandHidesBeltDataset: 'Левая рука закрывает ремень',
      rightHandHidesBelt: 'Правая рука закрывает ремень?',
      rightHandHidesBeltDataset: 'Правая рука закрывает ремень'
    },
    [CriticalDatasetLabels.DETECTORS]: {
      beltFasten: 'Ремень пристегнут?',
      beltFastenDataset: 'Ремень пристегнут',
      beltFastenBehindBack: 'Ремень пристегнут за спиной?',
      beltFastenBehindBackDataset: 'Ремень пристегнут за спиной',
      phoneFront: 'Телефон спереди?',
      phoneFrontDataset: 'Телефон спереди',
      phoneAroundEar: 'Сторона лица, когда телефон находится у уха:',
      phoneAroundEarDataset: 'Ухо, сторона лица:',
      phoneKeptByShoulder: 'Сторона лица, когда телефон держится плечом:',
      phoneKeptByShoulderDataset: 'Плечо, сторона лица:',
      messagePhoneVisible: 'Виден ли телефон при написании сообщения?',
      messagePhoneVisibleDataset: 'Телефон виден, написание сообщения',
      eatState: 'Водитель ест',
      drinkState: 'Водитель пьет',
      cigaretteState: 'Водитель курит сигарету',
      cigaretteStateDataset: 'Cигарета',
      pipeState: 'Водитель курит трубку',
      pipeStateDataset: 'Трубка',
      eCigaretteState: 'Водитель курит электронную сигарету',
      eCigaretteStateDataset: 'Электронная сигарета',
      faceIntersection: 'Перекрывает лицо',
      beltIntersection: 'Перекрывает ремень',
      holdedObject: 'Предмет в руках'
    },
    enums: {
      HumanEntrySex: {
        [HumanEntrySex.MALE]: 'Мужчина',
        [HumanEntrySex.FEMALE]: 'Женщина'
      },
      HumanEntryWearingType: {
        [HumanEntryWearingType.SINGLE_COLORED]: 'Одноцветная',
        [HumanEntryWearingType.PICTURED_CLOTHES]: 'С картинкой',
        [HumanEntryWearingType.STRIPED_CLOTHES]: 'В полоску',
        [HumanEntryWearingType.PLAID_CLOTHES]: 'В клетку',
        [HumanEntryWearingType.OTHER_CLOTHES]: 'Иное'
      },
      HumanEntryGlasses: {
        [HumanEntryGlasses.NONE]: 'Нет',
        [HumanEntryGlasses.NORMAL]: 'Обычные очки',
        [HumanEntryGlasses.BLACK]: 'Темные очки'
      },
      LightConditionsType: {
        [LightConditionsType.DAY_TIME]: 'День',
        [LightConditionsType.NIGHT_TIME]: 'Ночь',
        [LightConditionsType.GLARE]: 'Яркое солнце / блики',
        [LightConditionsType.DUSK]: 'Сумерки'
      },
      HumanEntryHair: {
        [HumanEntryHair.LONG_HIDING]: 'Длинные и скрывающие ремень',
        [HumanEntryHair.SHORT]: 'Короткие'
      },
      LightConditionsSun: {
        [LightConditionsSun.NONE]: 'Отсутствует',
        [LightConditionsSun.LEFT]: 'Слева',
        [LightConditionsSun.RIGHT]: 'Справа',
        [LightConditionsSun.BEHIND]: 'Сзади',
        [LightConditionsSun.FRONT]: 'Спереди'
      },
      DetectorDirection: {
        [DetectorDirection.NONE]: 'Отсутствует',
        [DetectorDirection.LEFT]: 'Левое',
        [DetectorDirection.RIGHT]: 'Правое'
      },
      DetectorFoodEat: {
        [DetectorFoodEat.NONE]: 'Ничего',
        [DetectorFoodEat.FRUIT]: 'Фрукт',
        [DetectorFoodEat.SANDWICH]: 'Бутерброд',
        [DetectorFoodEat.SMALL_FOOD]: 'Маленькая еда',
        [DetectorFoodEat.OTHER]: 'Иное'
      },
      DetectorFoodDrink: {
        [DetectorFoodDrink.NONE]: 'Ничего',
        [DetectorFoodDrink.BOTTLE]: 'Бутылка',
        [DetectorFoodDrink.GLASS]: 'Стакан',
        [DetectorFoodDrink.CUP]: 'Кружка',
        [DetectorFoodDrink.OTHER]: 'Иное'
      },
      DetectorSmokeDirection: {
        [DetectorSmokeDirection.NONE]: 'Нет',
        [DetectorSmokeDirection.LEFT_HAND]: 'Держит в левой руке',
        [DetectorSmokeDirection.RIGHT_HAND]: 'Держит в правой руке',
        [DetectorSmokeDirection.MOUTH]: 'Держит во рту'
      }
    }
  },
  shared: {
    abbreviation: {
      seconds: 'с.',
      minutes: 'м.',
      hours: 'ч.',
      days: 'д.'
    },
    send: 'Отправить',
    edit: 'Изменить',
    save: 'Сохранить',
    apply: 'Применить',
    search: 'Поиск',
    field: 'Поле',
    value: 'Значение'
  },
  charts: {
    criticalEventsDistribution: 'Распределение критических событий за месяц',
    criticalEventsDoughnut: 'Итоговое количество критических событийm',
    driverSpecific: 'Выбор водителя',
    axis: {
      count: 'Количество',
      date: 'Время'
    },
    filters: {
      title: 'Фильтры графиков',
      date: {
        title: 'Выбор временного промежутка поездок'
      },
      period: {
        title: 'Периодичность времени на графиках',
        label: 'Период: ',
        minute: 'Минута',
        hour: 'Час',
        day: 'День',
        week: 'Неделя',
        month: 'Месяц'
      }
    }
  },
  reports: {
    title: 'Отчеты',
    datasetTitle: 'Отчет датасета',
    emptySearchLabel: 'Все водители включены',
    generateButton: 'Создать отчет',
    criticalArchive: {
      title: 'Фотографии датасета',
      download: 'Загрузить архив'
    }
  },
  carParks: {
    title: 'Управление автопарками',
    header: 'Водители',
    role: 'Роль',
    after: 'Начало показа поездок',
    before: 'Конец показа поездок',
    actions: 'Действия',
    restricted: 'Ограничен в правах?',
    roles: {
      [carParkRole.DRIVER]: 'Водитель',
      [carParkRole.MANAGER]: 'Менеджер'
    },
    driverIcons: {
      [ComponentMode.CREATE]: 'Внести водителя',
      [ComponentMode.EDIT]: 'Изменить водителя',
      [ComponentMode.REMOVE]: 'Удалить водителя'
    },
    carParkIcons: {
      [ComponentMode.CREATE]: 'Создать автопарк',
      [ComponentMode.EDIT]: 'Изменить автопарк',
      [ComponentMode.REMOVE]: 'Удалить автопарк'
    },
    removeDriverDialog: {
      title: 'Удаление водителя автопарка',
      text: 'Вы действительно хотите удалить водителя {0} из автопарка?'
    },
    removeCarParkDialog: {
      title: 'Удаление автопарка',
      text: 'Вы действительно хотите удалить автопарк? Вся информация о водителях автопарка также будет удалена!'
    },
    carParkForm: {
      titles: {
        [ComponentMode.CREATE]: 'Создать автопарк',
        [ComponentMode.EDIT]: 'Изменить автопарк'
      },
      errors: {
        title: 'Название автопарка не должно быть пустым.'
      },
      success: {
        [ComponentMode.CREATE]: 'Автопарк был успешно сохранен.',
        [ComponentMode.EDIT]: 'Автопарк был успешно сохранен.',
        [ComponentMode.REMOVE]: 'Автопарк был успешно удален.'
      }
    },
    driverForm: {
      titles: {
        [ComponentMode.CREATE]: 'Внести водителя автопарка',
        [ComponentMode.EDIT]: 'Изменить водителя автопарка'
      },
      autocompleteTitle: 'Водитель',
      manager: 'Менеджер?',
      restrictedManager: 'Менеджер ограничен в правах?',
      success: {
        [ComponentMode.CREATE]: 'Водитель был успешно сохранен или изменен.',
        [ComponentMode.REMOVE]: 'Водитель был успешно удален.'
      },
      errors: {
        nonNullableDate: 'Дата должна быть выбрана',
        wrongRangeOrder: 'Стартовая дата должна быть меньше финальной',
        nonSelectedDriver: 'Необходимо выбрать водителя'
      }
    }
  },
  errors: {
    connectionRefused: 'Соединение с сервером не установлено!',
    generalError: 'Произошла ошибка на стороне сервера!',
    permissionsError: 'Данная операция не разрешена для пользователя!',
    unauthorizedError: 'Необходимо авторизироваться для доступа к странице!',
    [BackendEndpoints.MAP_DRIVER_PROFILE]: {
      'user_id': 'Водитель не указан для операции извлечения настроек!',
      'profile': 'Профиль водителя не найден!',
      'settings': 'Настройки водителя не найдены!'
    },
    [BackendEndpoints.SETTINGS_FETCH_DEFAULT]: {
      'default_settings': 'Настройки по умолчанию не найдены на сервере!'
    }

  },

  sqlHelperDialog: {
    title: 'SQL Helper',
    pureEventsOld: 'Pure events (old)',
    pureEventsNew: 'Pure events (new)',
    criticalCurrent: 'Current critical event',
    criticalAll: 'All critical events'
  },

  // internal vuetify stuff
  close: 'Закрыть',
  dataIterator: {
    pageText: '{0}-{1} из {2}',
    noResultsText: 'Не найдено подходящих записей',
    loadingText: 'Запись загружается...'
  },
  dataTable: {
    itemsPerPageText: 'Строк на странице:',
    ariaLabel: {
      sortDescending: ': Упорядочено по нисходящей. Активируйте, чтобы убрать сортировку.',
      sortAscending: ': Упорядочено во восходящей. Активируйте для упорядочивания по ниcходящей.',
      sortNone: ': Не упорядочено. Активируйте для упорядочивания по восходящей.'
    },
    sortBy: 'Сортировать по'
  },
  dataFooter: {
    itemsPerPageText: 'Записей на странице:',
    itemsPerPageAll: 'Все',
    nextPage: 'Следующая страница',
    prevPage: 'Предыдущая страница',
    firstPage: 'Первая страница',
    lastPage: 'Последняя страница',
    pageText: '{0}-{1} из {2}'
  },
  datePicker: {
    itemsSelected: '{0} выбран'
  },
  noDataText: 'Отсутствуют данные',
  carousel: {
    prev: 'Предыдущий визуальный',
    next: 'Следующий визуальный'
  },
  calendar: {
    moreEvents: 'Еще {0}'
  },
  fileInput: {
    counter: 'Файлов: {0}',
    counterSize: 'Файлов: {0} (всего {1})'
  }
}
